/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { miscGetMiscRandomnumber } from "../../funcs/miscGetMiscRandomnumber.js";
import { GetMiscRandomnumberRequest$zodSchema } from "../../models/getmiscrandomnumberop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: GetMiscRandomnumberRequest$zodSchema.optional(),
};

export const tool$miscGetMiscRandomnumber: ToolDefinition<typeof args> = {
  name: "misc-get-misc-randomnumber",
  description: `随机数生成

需要一个简单的随机数，还是需要一串不重复的、带小数的随机数？这个接口都能满足你！

## 功能概述
这是一个强大的随机数生成器。你可以指定生成的范围（最大/最小值）、数量、是否允许重复、以及是否生成小数（并指定小数位数）。

## 流程图
\`\`\`mermaid
graph TD


    A[开始] --> B{参数校验};
    B --> |通过| C{是否允许小数?};
    C --> |是| D[生成随机小数];
    C --> |否| E[生成随机整数];
    D --> F{是否允许重复?};
    E --> F;
    F --> |是| G[直接生成指定数量];
    F --> |否| H[生成不重复的数字];
    G --> I[返回结果];
    H --> I;
    B --> |失败| J[返回 400 错误];
\`\`\`
## 使用须知
> [!WARNING]
> **不重复生成的逻辑限制**
> 当设置 \`allow_repeat=false\` 时，请确保取值范围 \`(max - min + 1)\` 大于或等于你请求的数量 \`count\`。否则，系统将无法生成足够的不重复数字，请求会失败并返回 400 错误。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await miscGetMiscRandomnumber(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
